export enum FieldShowValue {
  Show = 'Show',
  Hide = 'Hide',
  AlwaysHide = 'AlwaysHide',
  IdeaCreation = 'Show',
  Idea = 'Idea',
  ConceptReview = 'ConceptReview'
}
